<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vue Monica Refine Design
      Author: Riyan Kurniawan
    -- MONICA --
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Recover your password</h4>
                  <p>Please enter your email address and we'll send you instructions on how to reset your password.</p>
                </div>

                <vs-input type="email" label-placeholder="Email" v-model="email" class="w-full mb-8"/>
                <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto ">Back To Login</vs-button>
                <vs-button
                    class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0 btn-load-1 vs-con-loading__container"
                    @click="reset()">Recover Password
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import * as REPO from '../../repository/index';

export default {
  data() {
    return {
      email: ''
    }
  },
  mounted() {

  },
  methods: {
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45
      });
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    reset() {
      let id = this.$route.params.id;
      if (this.email !== '') {
        this.loadingBtnStart('btn-load-1');
        let dataForm = {
          email: this.email
        };
        REPO.forgotPassword(dataForm).then(res => {
          this.loadingBtnStop('btn-load-1');
          if (res.data.status == "true") {
            this.$emit('submitModal', false);
            this.$toast.success('Email Successfully Has Been Sent.');

            setTimeout(() => {
              this.$router.push('/pages/login')
            }, 2000)
          } else {
            this.$toast.error(res.data.error_msg);
          }
        }).catch(err => {
          this.loadingBtnStop('btn-load-1');
          // (err);
          this.$toast.error(err.message);
        });
      } else {
        this.$toast.error("Please Fill up the Email Address");
      }

    }
  }
}
</script>
